
import Vue from "vue";
export default Vue.extend({
  props: {
    title: String,
    texto: String,
    color: {
      type: String,
      default: "info",
    },
    width: {
      type: String,
      default: "350px",
    },
    headers: [],
    items: [],
    listaColumnas: [],
    listaDatos: [],
  },
  computed: {
    tieneColumnaYDatos() {
      return this.listaColumnas && this.listaDatos;
    },
    tieneHeadersYItems() {
      return this.headers && this.items;
    },
  },
});
